import { Navigate, Outlet, useLocation } from 'react-router-dom';

// Local Imports
import { useIsAuthenticatedUser } from '../utils/utils';

const PrivateRoutes = () => {
  const location = useLocation();
  const { isAuthenticated } = useIsAuthenticatedUser();
  const isProjectInviteRoute = location.pathname.startsWith('/projects/invite/');
  const isTeamInviteRoute = location.pathname.startsWith('/teams/invite/');

  if (isProjectInviteRoute || isTeamInviteRoute) {
    return <Outlet />;
  }

  if (isAuthenticated) {
    return <Outlet />;
  } else {
    return <Navigate to='/login' replace state={{ from: location }} />;
  }
}

export default PrivateRoutes
